var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrackingAwardTagIncrease(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.3125 1.28125V10.9062C1.3125 11.2891 1.58594 11.5625 1.96875 11.5625H13.3438C13.6992 11.5625 14 11.8633 14 12.2188C14 12.6016 13.6992 12.875 13.3438 12.875H1.96875C0.875 12.875 0 12 0 10.9062V1.28125C0 0.925781 0.273438 0.625 0.65625 0.625C1.01172 0.625 1.3125 0.925781 1.3125 1.28125ZM8.75 3.90625C8.75 3.55078 9.02344 3.25 9.40625 3.25H12.4414C12.8242 3.25 13.0977 3.55078 13.0977 3.90625V6.96875C13.0977 7.35156 12.8242 7.625 12.4414 7.625C12.0859 7.625 11.7852 7.35156 11.7852 6.96875V5.49219L8.75 8.52734C8.50391 8.80078 8.09375 8.80078 7.84766 8.52734L5.6875 6.36719L3.96484 8.08984C3.69141 8.36328 3.28125 8.36328 3.03516 8.08984C2.76172 7.84375 2.76172 7.43359 3.03516 7.1875L5.22266 5C5.46875 4.72656 5.87891 4.72656 6.15234 5L8.3125 7.16016L10.8828 4.5625H9.40625C9.02344 4.5625 8.75 4.28906 8.75 3.90625Z",
    fill: "#417539"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackingAwardTagIncrease);
export default __webpack_public_path__ + "static/media/TrackingAwardTagIncrease.45ecf9e0c9b868ca5f67a4907479c606.svg";
export { ForwardRef as ReactComponent };